// extracted by css-extract-rspack-plugin
export default {"TaxInformationText":"TooltipTaxInformation_TaxInformationText__7f-m4","Wrapper":"TooltipTaxInformation_Wrapper__03d7-"};